// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--tiXgg","layout":"_7a3fb80146--layout--KDj34","promo":"_7a3fb80146--promo--zR4d2","previews":"_7a3fb80146--previews--nJpZ8"};